import { render, staticRenderFns } from "./OrthoFootSize.vue?vue&type=template&id=14eb49b1&scoped=true"
import script from "./OrthoFootSize.vue?vue&type=script&lang=js"
export * from "./OrthoFootSize.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14eb49b1",
  null
  
)

export default component.exports